import React, {useState, useContext, useEffect} from 'react'
import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";
import { slide as Menu } from 'react-burger-menu'
import LogoPrMrthn from "../../img/header_logo.png";
import { trackMenuClick } from "../../analytics";

function Header() {

    const [menuState, setMenuState] = useState()
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    var isMenuOpen = function(state) {
        return state.isOpen;
    };

    useEffect(() => {
        isMenuOpen === false ? setMenuState(true) : setMenuState(false)
    })

    function toggleMenu() {
        setMenuState(true)
    }

    const handleMenuClick = (menuItem) => {
        trackMenuClick(menuItem);
        toggleMenu();
    };
    const linkClass = `
        relative transition-colors duration-300 
        hover:text-[#e8b500]
        after:content-[''] after:absolute after:left-0 after:-bottom-1 
        after:h-[2px] after:w-0 after:bg-[#e8b500] 
        after:transition-all after:duration-300 
        hover:after:w-full
    `;
    return (
        
        <>
            <header className={offset >= 150 ? 'py-2 bg-[#babafe] border-b-1 fixed top-0 left-0 w-full z-50 border-b border-b-black' : 'bg-[#babafe] py-3 fixed top-0 left-0 w-full z-50'} style={{transition: '0.5s'}}>
                <div className="container max-w-screen-xl px-3 gap-3 mx-auto flex justify-between items-center relative">
                    <a href="/" className="w-[120px] lg:w-[230px] order-1">
                        <img 
                            src={LogoPrMrthn} 
                            alt="GET"
                            className={`
                                w-full transition-all duration-500
                                ${offset >= 150 ? 'lg:w-[180px]' : 'lg:w-[230px]'}
                            `}
                        />
                    </a>
                    <div className="block lg:hidden order-3 relative">
                        <Menu onStateChange={isMenuOpen} isOpen={menuState} pageWrapId={"page-wrap"}>
                            <nav id="page-wrap">
                                <ul>

                                    <li className="mb-3 text-black relative z-10">
                                        <Link
                                        to="ebaut"
                                        onClick={() => handleMenuClick('Про івент')}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Про івент</Link>
                                    </li>
                                    <li className="mb-3 text-black relative z-10"><Link
                                        to="speacers-old"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Спікери 2025</Link>
                                    </li>
                                    <li className="text-black relative z-10"><Link
                                        to="formats"
                                        onClick={() => handleMenuClick('Формати участі')}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Формати участі</Link>
                                    </li>
                                    
                                    {/*<li className="mb-3 text-black relative z-10"><Link
                                        to="programm"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Програма 2026</Link>
                                    </li>
                                    <li className="text-black relative z-10"><Link
                                        to="formats"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}>Формати участі</Link>
                                    </li>*/}
                                </ul>
                            </nav>
                        </Menu>

                        
                    </div>
                        <nav className="hidden lg:block order-2" id="page-wrap">
                            <ul className="font-medium gap-4 flex xl:gap-14 xl:uppercase">

                                <li>
                                    <Link
                                        className={linkClass}
                                        to="ebaut"
                                        onClick={() => handleMenuClick('Про івент')}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                    >
                                        Про івент
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={linkClass}
                                        to="speacers-old"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                    >
                                        Спікери 2025
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={linkClass}
                                        to="formats"
                                        onClick={() => handleMenuClick('Формати участі')}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                    >
                                        Формати участі
                                    </Link>
                                </li>
                                
                                {/*<li>
                                    <Link
                                        className={linkClass}
                                        to="programm"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                    >
                                        Програма 2026
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={linkClass}
                                        to="formats"
                                        onClick={toggleMenu}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                    >
                                        Формати участі
                                    </Link>
                                </li>*/}

                            </ul>
                        </nav>

                      <Link to="frstscrn" spy={true}
                          smooth={true}
                          offset={-70}
                          duration={500}
                          onClick={() => handleMenuClick('Формати участі')}
                          className="order-2 text-sm leading-none bg-[#ffd97c] ml-auto py-2 px-[14px] font-bold uppercase
                            hover:scale-105 transition-all tracking-widest duration-300 ease-out whitespace-nowrap
                                lg:order-3  lg:px-12 lg:py-3 lg:text-base lg:ml-0">
                        <span>взяти участь</span>
                    </Link>
                </div>

            </header>
        </>
    )
}

export default Header;